import React, { useEffect, useState } from "react";
import { fechaActual, HoraActual } from "../../../hooks/UseDate";
import {
  postActualizarEstadoSuministroDevolucionesQxFarmacia,
  postActualizarUserDevolucionesQx,
  postActualizarUserDevolucionesQxFarmacia,
  postDespachoQxBodegaFarmacia,
  postInconsistenciaDevolucionesQx,
  postInsertarDataDevolucionesQx,
  postPDFDevolucionesQxFarmacia,
} from "../../../services/FarmaciaRuta";
import Loading from "../../Loading";
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalDescargarPDFSuministrosDevueltosQxFarmacia from "./ModalDescargarPDFSuministrosDevueltosQxFarmacia";
// import ModalValidarInconsistencias from "./ModalValidarInconsistencias";
// import ModalInconsistenciasPDFDevolucionesQx from "./ModalInconsistenciasPDFDevolucionesQx";
import ModalValidacionSuministrosBodegaDevolucionQX from "./ModalValidacionSuministrosBodegaDevolucionQX";


const ModalConfirmarDevolucionesQxFarmacia = ({
  item,
  setmodalOnConfirmarDevoluciones,
  dataEnfermeria,
  actualizarData,
  cerrarModal,
}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [loading, setloading] = useState(true);
  const [loadingBodega, setloadingBodega]=useState(true)
  // const [dataBodega, setdataBodega] = useState([]);
  const [informePDFDevoluciones, setinformePDFDevoluciones]=useState([])
  const [devolucionBodega,setdevolucionBodega]=useState('')
  const [bodegas,setbodegas]=useState([])
  const [dataDevolucionesPDF, setdataDevolucionesPDF]=useState([])
  const [errorBodega,seterrorBodega]=useState('')
  // const [modalOnInconsistencias, setmodalOnInconsistencias]=useState(false)
  const [dataInconsistencias, setdataInconsistencias]=useState([])
  const [validarIncosistencias, setvalidarIncosistencias]=useState(true)
  const [validarBodegasDevoluciones, setvalidarBodegasDevoluciones]=useState(false)
  const [seleccionarButton, setseleccionarButton]=useState(false)
  const [noHayRelacionesEntreBodegas,setnoHayRelacionesEntreBodegas]= useState([])
  const [noHayCanitdadesADevolver, setnoHayCanitdadesADevolver]=useState([])
  const [PDFDevoluciones, setPDFDevoluciones]=useState([])
  const handleCancelClick = () => {
    setmodalOnConfirmarDevoluciones(false);
  };

  const handleOnsubmitDevolverValidacionBodega=()=>{
    setvalidarBodegasDevoluciones(true)
  }

  const handleOnsubmitDevolver = () => {
    //e.preventDefault();
    //Validar las inconsistencias
    console.log(validarIncosistencias,'validarIncosistencias')
    // const inconsistencias ={
    //   EMPCOD: '1',
    //   BODEGA: item.BodQf,
    //   ProMCDpto:usuarioInfo.Sede,
    //   ProEmpCod:usuarioInfo.Empresa,
    //   PQEdoIte:'S',
    //   PQEstDes:'S',
    //   PQEdoCaI:'N',
    //   ProMCDpto:usuarioInfo.Sede,
    //   ProCirCod: item.ProCirCod,
    //   BodCSbBod: devolucionBodega
    // }
    //postInconsistenciaDevolucionesQx(inconsistencias).then((res)=>{
    //console.log(res.data,'inconsistencias')
    //   if(res.data.length !== 0){
    //     console.log('Entro')
    //     //setdataInconsistencias(res.data)
    //     setmodalOnInconsistencias(true)
    //   }else{
    //     console.log('NO Entro')
        const updateUser = {
      ProEmpCod: usuarioInfo.Empresa,
      ProMCDpto: usuarioInfo.Sede,
      ProCirCod: item.ProCirCod,
      ProIndUso: "V",
      ProUsuUso:usuarioInfo.UsuarioEncriptado,
    };
    console.log(updateUser, "actualizar user data entra");
    postActualizarUserDevolucionesQx(updateUser).then((res) => {
      setloading(false)
      console.log(res.data, "actualizar user");
      //////
      const dataInsert = {
        ProEmpCod: usuarioInfo.Empresa,
        ProMCDpto: usuarioInfo.Sede,
        ProCirCod: item.ProCirCod,
        PaqCod: item.PaqCod,
        PQCvoDes: "3",
        PQTpoTRN: "DV",
        PQFecHDes: `${fechaActual()} ${HoraActual()}`,
        PQCntMov: "1",
        PQUsrMov: usuarioInfo.UsuarioEncriptado,
        PQEmpCod: usuarioInfo.Empresa,
        PQCodDoc: "   ",
        PQNumDoc: "0",
        PQSedMov: usuarioInfo.Sede,
        PQPabellon: item.ProCons,
        PqPadCed: dataEnfermeria.idEnfermeria,
        PQBodDes: devolucionBodega,//item.BodQf,
        PQSpsNL: "",
        BodCSbBod: devolucionBodega
      };
      console.log(dataInsert,'IMPORTANTE')
      postInsertarDataDevolucionesQx(dataInsert).then((res) => {
        console.log(res.data, "insert data");
        //////////////actualizar suministro
        const actualizarSuministro={
          ProCirCod:item.ProCirCod,
          PaqCod:item.PaqCod,
          ProEmpCod:usuarioInfo.Empresa,
          ProMCDpto:usuarioInfo.Sede,
          PQEdoDes:'V'
        }
        postActualizarEstadoSuministroDevolucionesQxFarmacia(actualizarSuministro).then((res)=>{
          console.log(res.data,'data actualizar suministro')
          
          //actualizar user
            const actualizarUser={
              ProCirCod:item.ProCirCod,
              ProIndUso:'N',
              ProEmpCod:usuarioInfo.Empresa,
              ProMCDpto:usuarioInfo.Sede,
              ProUsuUso:usuarioInfo.UsuarioEncriptado
            }
            postActualizarUserDevolucionesQxFarmacia(actualizarUser).then((res)=>{
              actualizarData(actualizarSuministro)
              console.log(res.data,'actualizar user')
              setmodalOnConfirmarDevoluciones(false);
              cerrarModal(false)
              setTimeout(() => {          
                setloading(true)
              }, 1000);
            })
        })
      })
      // .catch((error)=>{
      //   const actualizarSuministro={
      //     ProCirCod:item.ProCirCod,
      //     PaqCod:item.PaqCod,
      //     ProEmpCod:'1',
      //     ProMCDpto:'',
      //     PQEdoDes:'V'
      //   }
      //   postActualizarEstadoSuministroDevolucionesQxFarmacia(actualizarSuministro).then((res)=>{
      //     console.log(res.data,'data actualizar suministro')
          
      //     //actualizar user
      //       const actualizarUser={
      //         ProCirCod:item.ProCirCod,
      //         ProIndUso:'N',
      //         ProEmpCod:'1',
      //         ProMCDpto:'',
      //         ProUsuUso:''
      //       }
      //       postActualizarUserDevolucionesQxFarmacia(actualizarUser).then((res)=>{
      //         actualizarData(actualizarSuministro)
      //         console.log(res.data,'actualizar user')
      //         setmodalOnConfirmarDevoluciones(false);
      //         cerrarModal(false)
      //         setTimeout(() => {          
      //           setloading(true)
      //         }, 1000);
      //       })
      //   })

      // });
    });
      
    //})
  }

   


  useEffect(() => {
    //console.log(item, "item");
    seterrorBodega('Seleccionar Bodega Despacho')
    setloading(false)
    const bodega = {
      EMPCOD: usuarioInfo.Empresa,
      AUsrId: usuarioInfo.usuario,
      BodDspPis: "S",
      MCDpto: usuarioInfo.Sede,
    };
    postDespachoQxBodegaFarmacia(bodega).then((res) => {
      setbodegas(res.data);
    });

    const devolucionesPDF={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod:item.ProCirCod,
      PaqCod:item.PaqCod,
      MPCedu: item.MPCedu
    }
    //console.log(devolucionesPDF,'antes pdf devoluciones')
    postPDFDevolucionesQxFarmacia(devolucionesPDF).then((res)=>{
      //console.log(res.data,'data pdf devoluciones')
      if(res.data.length !== 0){
        let infoPDF=''
        let dataPDF= res.data
        setdataDevolucionesPDF(dataPDF)
        dataPDF.forEach(item => {
          infoPDF += `\n*${item.MSRESO}     ${item.PQCaSuSl}            ${item.PQCaSuDs}              ${item.PQCaSuUs}                ${(parseInt(item.PQCaSuDs) - parseInt(item.PQCaSuUs)) === NaN?(parseInt(item.PQCaSuDs) - parseInt(item.PQCaSuUs)):'0'}`
        });
        //console.log(infoPDF)
        setinformePDFDevoluciones(infoPDF)
        setTimeout(() => {          
          setloading(true)
        }, 2000);
      }
    })

  }, []);

  const handleOnchangeBodega=(e)=>{
    
    if(e.target.value !== 'Seleccionar Bodega'){
      
      seterrorBodega('')
      setdevolucionBodega(e.target.value)
      isInconsistencias(e.target.value)
    }else{
      
      seterrorBodega('Seleccionar Bodega Despacho')
    }
  }

  const isInconsistencias =(bodegaDevolucion)=>{
    setloadingBodega(false)
    const inconsistencias ={
      //EMPCOD: '1',
      //BODEGA: item.BodQf,
      ProMCDpto:usuarioInfo.Sede,
      ProEmpCod:usuarioInfo.Empresa,
      PaqCod: item.PaqCod,
      
      ProCirCod: item.ProCirCod,
      BodCSbBod: bodegaDevolucion//devolucionBodega
    }
    //let validarInconsistencias = true
    //console.log(inconsistencias,'inconsistencias')
    postInconsistenciaDevolucionesQx(inconsistencias).then((res)=>{
      setloadingBodega(true)
       let validarBodega = res.data.NoHayRelacionesEntreBodegas.some((item)=> item.NoHayRelacionBodegas === "si hay relaciones entre bodegas")
        //console.log(validarBodega,'validarBodega')    
        if(!validarBodega){
          setvalidarBodegasDevoluciones(true)
          setseleccionarButton(false)
        }else{
          setseleccionarButton(true)
        }    
       //console.log(res.data,'InconsistenciaDevolucionesQx')
       let arrayBodegas = res.data.NoHayRelacionesEntreBodegas
       console.log(arrayBodegas,'arrayBodegasss')
       const arrayCantidadDespachadaSolicitadaDevueltaUsada = arrayBodegas.map((agregarCantidades)=>{
          let cantidad = dataDevolucionesPDF.find((conCantidades)=> conCantidades.MSRESO.trim() === agregarCantidades.MSRESO.trim())
          //console.log(cantidad,'cantidad')
          if(cantidad){
            return {
              ...agregarCantidades,
              PQCaSuDs: cantidad.PQCaSuDs,
              PQCaSuDv: cantidad.PQCaSuDv,
              PQCaSuPe: cantidad.PQCaSuPe,
              PQCaSuSl: cantidad.PQCaSuSl,
              PQCaSuUs: cantidad.PQCaSuUs,
            }
          }
          return agregarCantidades
       })

       console.log(arrayCantidadDespachadaSolicitadaDevueltaUsada,'array nuevooooo')
       setPDFDevoluciones(arrayCantidadDespachadaSolicitadaDevueltaUsada)
      //  arraySinPrecios = arraySinPrecios.map(objSinPrecio => {
      //   let objetoConPrecio = arrayConPrecios.find(obj => obj.id === objSinPrecio.id);
      //   if (objetoConPrecio) {
      //     return {
      //       ...objSinPrecio,
      //       precio: objetoConPrecio.precio
      //     };
      //   }
      //   return objSinPrecio;
      // });


       //console.log(dataDevolucionesPDF,'dataDevolucionesPDF')
       setnoHayRelacionesEntreBodegas(res.data.NoHayRelacionesEntreBodegas)

       const arrayNoHayCantidadesADevolver = res.data.noHayCanitdadesADevolverSuministros.map((agregarCantidades)=>{
        let cantidad = dataDevolucionesPDF.find((conCantidades)=> conCantidades.MSRESO.trim() === agregarCantidades.MSRESO.trim())
        //console.log(cantidad,'cantidad')
        if(cantidad){
          return {
            ...agregarCantidades,
            PQCaSuDs: cantidad.PQCaSuDs,
            PQCaSuDv: cantidad.PQCaSuDv,
            PQCaSuPe: cantidad.PQCaSuPe,
            PQCaSuSl: cantidad.PQCaSuSl,
            PQCaSuUs: cantidad.PQCaSuUs,
          }
        }
        return agregarCantidades
     })
     //console.log(arrayNoHayCantidadesADevolver,'arrayNoHayCantidadesADevolver')
       setnoHayCanitdadesADevolver(arrayNoHayCantidadesADevolver)
    //   if(res.data.length !== 0){
    //    // validarInconsistencias = false
    //    console.log('false*')
    //    setvalidarIncosistencias(false)
    //    setdataInconsistencias(res.data)
    //   }else{
    //    // validarInconsistencias = true
    //    console.log('true*')
    //    setvalidarIncosistencias(true)
    //   }
    })
    //return validarInconsistencias
  }
  //console.log(isInconsistencias(),'isInconsistencias')
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none pt-6">
        <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Devolver
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          {loading ? (
            <form >
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-2/6  ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Paciente
                    </label>
                    <input
                      defaultValue={item.MPNOMC}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/6  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugia
                    </label>
                    <input
                      defaultValue={item.ProCirCod}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/6  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Paquete
                    </label>
                    <input
                      //onChange={handleOnchange}
                      defaultValue={item.PaqCod}
                      disabled={true}
                      //name='cantidadSuministro'
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/6  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre Paquete
                    </label>
                    <input
                      //onChange={handleOnchange}
                      defaultValue={item.PaqDes}
                      disabled={true}
                      //name='cantidadSuministro'
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/3  ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Recibe
                    </label>
                    <input
                      defaultValue={dataEnfermeria.idEnfermeria}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Recibe Nombre
                    </label>
                    <input
                      //defaultValue={item.MSNomG}
                      defaultValue={dataEnfermeria.nombreEnfermeria}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Bodega devolucion
                    </label>
                    <select
                      //disabled={true}
                      onChange={handleOnchangeBodega}
                      name="bodegasSelect"
                      className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                      aria-label="Default select example"
                    >
                      <option>Seleccionar Bodega</option>
                      {bodegas.map((item) => (
                        <option value={item.BODEGA} key={item.BODEGA}>
                          {item.BODEGA}- {item.BODDESC}
                        </option>
                      ))}
                    </select>
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                      {errorBodega}
                    </label>
                  </div>
                  {/* <div className="w-1/3  px-1 ">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label inline-block mb-2 text-gray-900 font-medium"
                    >
                      Bodega destino
                    </label>

                    <select
                      //disabled={true}
                      name="estadosSelect"
                      className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                      aria-label="Default select example"
                    >
                      {dataBodega.map((item) => (
                        <option value={item.BODEGA} key={item.BODEGA}>
                          {item.BODEGA}- {item.BODDESC}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>
              </div>

              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                {
                  seleccionarButton?
                  <PDFDownloadLink document={<ModalDescargarPDFSuministrosDevueltosQxFarmacia informePDFDevoluciones={informePDFDevoluciones} dataDevolucionesPDF={dataDevolucionesPDF} item={item} dataInconsistencias={dataInconsistencias} devolucionBodega={devolucionBodega} noHayRelacionesEntreBodegas={noHayRelacionesEntreBodegas} noHayCanitdadesADevolver={noHayCanitdadesADevolver} PDFDevoluciones={PDFDevoluciones}/>} fileName="devolucionesSuministrosllll.pdf">
                    <button
                      type="button"
                      onClick={handleOnsubmitDevolver}
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Devolver
                    </button>
                  </PDFDownloadLink>
                  :
                  // <PDFDownloadLink document={<ModalInconsistenciasPDFDevolucionesQx informePDFDevoluciones={informePDFDevoluciones} dataDevolucionesPDF={dataDevolucionesPDF} item={item} dataInconsistencias={dataInconsistencias} devolucionBodega={devolucionBodega}/>} fileName="incosistenciasDelucionessssass.pdf">
                    <button
                      type="button"
                      onClick={handleOnsubmitDevolverValidacionBodega}
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Devolver
                    </button>
                  // </PDFDownloadLink>

                }
                
              </div>
            </form>
          ) : (
            <div className="text-center py-40">
              {/* <label>Disculpe estamos guardando la información!!</label> */}
              <Loading />
            </div>
          )}
        </div>
      </div>
      {/* {modalOnInconsistencias? <ModalValidarInconsistencias setmodalOnInconsistencias={setmodalOnInconsistencias}/>:null} */}
      {
                              loadingBodega?
                              null:
                              <div className="relative flex items-center justify-center h-screen">      
                                  <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                    <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                      <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                      <p className="mt-4 text-lg">Cargando</p>
                                    </div>
                                  </div>                              
                                </div>
                            }   
                            {validarBodegasDevoluciones? <ModalValidacionSuministrosBodegaDevolucionQX setvalidarBodegasDevoluciones={setvalidarBodegasDevoluciones}/>:null}           
    </div>
  );
};

export default ModalConfirmarDevolucionesQxFarmacia;
